import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import rtl from 'styled-components-rtl';
import { constants } from '../../../../modules/utils/constants/constants';

interface ModalBodyProps {
  showList: boolean;
}

export const StyledMenuBody = styled.div<ModalBodyProps>`
  position: relative;
  overflow: hidden auto;
  height: fit-content;

  ::-webkit-scrollbar {
    width: ${toRem(14)};
  }

  ::-webkit-scrollbar-thumb {
    border: ${toRem(4)} solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    opacity: 0.5;
    border-radius: ${toRem(50)};
    background-color: ${baseVariables.color.neutral30};
  }

  ::-webkit-scrollbar-track {
    background-color: ${baseVariables.color.base20};
  }

  max-height: ${props => (props?.showList ? 'calc(100vh - 380px)' : !props?.showList ? 'calc(100vh - 650px)' : 'none')};

  @media ${baseVariables.mediaQuery.md} {
    max-height: ${props => (props?.showList ? '44vh' : !props?.showList ? 'calc(80vh - 800px)' : 'none')};
  }

  @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
    max-height: ${props => (props?.showList ? '50vh' : !props?.showList ? 'calc(80vh - 500px)' : 'none')};
  }
`;

export const StyledMainBundleContainer = styled.div`
  .package-border {
    // padding: ${toRem(12)};
    // border: 1px solid ${baseVariables.color.neutral20};
    // box-sizing: border-box;
    row-gap: ${toRem(12)};
  }

  .single-package-width {
    width: 100%;
    @media ${baseVariables.mediaQuery.sm} {
      width: 578px;
    }
  }

  @media ${baseVariables.mediaQuery.md}, @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
    row-gap: ${toRem(8)};
    // padding: ${toRem(16)} ${toRem(36)};
  }

  .diet-allergen-codes-info {
    column-gap: ${toRem(4)};
  }
`;

export const StyledTabNav = styled.ul`
  overflow: auto;
  cursor: grab;

  .active {
    cursor: grabbing;
  }

  ::-webkit-scrollbar {
    display: none;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  list-style-type: none;
  margin: 0;
  padding: 0;
  column-gap: ${toRem(24)};
  background-color: ${baseVariables.color.base20};
  box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.08);
  padding: 0 ${toRem(24)};

  @media ${baseVariables.mediaQuery.md}, @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
    padding: 0 ${toRem(44)};
    height: ${toRem(56)};
    max-height: ${toRem(56)};
  }

  li {
    cursor: pointer;
  }
`;

export const StyledSectionHeader = styled.div`
  width: 100%;
  border-bottom: 1px solid ${baseVariables.color.neutral20};
  padding: 0 0 ${toRem(8)} 0;
  margin: ${toRem(24)} 0 ${toRem(12)} 0;

  @media ${baseVariables.mediaQuery.md}, @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
    padding: 0 0 ${toRem(12)} ${toRem(36)};
    margin: ${toRem(24)} 0 ${toRem(16)} 0;
    ${rtl`
    &:is(${constants.RTL_LANG_LIST}) {
      padding: 0 ${toRem(36)} ${toRem(12)} 0;
    }
  `}
  }
`;

export const StyledMenuDetailsContainer = styled.div`
  width: 86%;
  max-width: 86%;
  padding: 0;

  @media ${baseVariables.mediaQuery.md}, @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
    width: 74%;
    max-width: 74%;
  }

  .section-item {
    row-gap: ${toRem(12)};

    @media ${baseVariables.mediaQuery.md},
      @media ${baseVariables.mediaQuery.lg},
      @media ${baseVariables.mediaQuery.xl} {
      row-gap: ${toRem(16)};
    }
  }

  .section-separator {
    border: 1px dashed ${baseVariables.color.neutral20};
  }

  .awp-menubody-rtl {
    ${rtl`
    &:is(${constants.RTL_LANG_LIST}) {
      text-align: right !important;
    }
  `}
  }
`;
